export const Logo = ({ dark = false, small = false }) => (
  <span className="inline-flex flex-col leading-none select-none" aria-label="AVENIR Relay">
    <span
      className={`font-op ${small ? 'text-[8px]' : 'text-[9px]'} font-medium uppercase tracking-[0.42em] ${
        dark ? 'text-[#8FA79E]' : 'text-[#6B7280]'
      }`}
    >
      AVENIR
    </span>
    <span
      className={`${small ? 'text-xl' : 'text-[26px]'} font-extrabold tracking-tight ${
        dark ? 'text-[#FAFAF7]' : 'text-[#0F5C4A]'
      }`}
    >
      relay<span className="text-[#2563EB]">.</span>
    </span>
  </span>
);
